import { IconProgressAlert } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { mergeWith, subtract } from 'lodash-es';
import { clone, isNonNullish } from 'remeda';
import {
  type AgedBalanceCompact,
  useLoadAgedBalanceCompact,
} from 'shared/hooks/use-load-aged-balance';
import { useSafeLocalizedCompactCurrencyFormatter } from 'shared/utils/currency';

import { BaseTicker } from '../BaseTicker';

function getAmountAtRisk(agedBalanceCompact: AgedBalanceCompact, formatter: Intl.NumberFormat) {
  const netOver90 = agedBalanceCompact.debits['90'] - agedBalanceCompact.credits['90'];

  return formatter.format(netOver90);
}

function getShareAtRisk(agedBalanceCompact: AgedBalanceCompact) {
  const netAgedBalance = mergeWith(
    clone(agedBalanceCompact.debits),
    agedBalanceCompact.credits,
    subtract,
  );

  const totalReceivable =
    netAgedBalance.notDue +
    netAgedBalance['0'] +
    netAgedBalance['30'] +
    netAgedBalance['60'] +
    netAgedBalance['90'];

  return netAgedBalance['90'] / totalReceivable;
}

export const AtRiskTicker = () => {
  const { t } = useTranslation();
  const { agedBalanceCompact, agedBalanceCompactError, isAgedBalanceCompactLoading } =
    useLoadAgedBalanceCompact();
  const formatter = useSafeLocalizedCompactCurrencyFormatter();

  if (isAgedBalanceCompactLoading || agedBalanceCompact == null) {
    return (
      <BaseTicker
        icon={IconProgressAlert}
        label={t(i18nKeys.ANALYTICS.TICKERS.AT_RISK.TITLE)}
        hasFailed={isNonNullish(agedBalanceCompactError)}
      />
    );
  }

  return (
    <BaseTicker
      icon={IconProgressAlert}
      label={t(i18nKeys.ANALYTICS.TICKERS.AT_RISK.TITLE)}
      value={getAmountAtRisk(agedBalanceCompact, formatter)}
      share={getShareAtRisk(agedBalanceCompact)}
      url="invoices?min_days_late=90&status=unpaid,recoverable"
    />
  );
};
